module.exports = __webpack_public_path__ + "img/nbus_main_title.a66086cd.png";